import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { REPORTS } from '../../constants';

import withModal from '../Modal/WithModal';
import { generateReportLink } from '../../ajax/endpoints';
import './ReportsModal.css';
import { ViewerPrimaryColorUserStyle } from '../UserCustomization';
import svgInline from '../SvgInline/SvgInline';
import closeIcon from '../../shared/assets/icon-close.svg';


export class ReportsModalComponent extends Component {
  constructor(props) {
    super(props);
    const { property } = props;

    // Passed in property can appear in a couple different formats
    const coordinates = property.coordinates || property.basicInfo.location.geoLocation.coordinates;
    const name = property.name || '';
    const city = property.city || property.basicInfo.location.city;
    const state = property.state || property.basicInfo.location.state;
    const country = property.country || property.basicInfo.location.country;

    this.reports = REPORTS[country];

    this.state = {
      areaType: 'DriveTimeBuffer',
      latitude: coordinates[1],
      longitude: coordinates[0],
      title: `${name} ${city}, ${state}`,
      sourceCountry: country,
      bufferUnits: 'minutes',
      bufferRadii: [1, 3, 5],
      report: REPORTS[country][0],
      reportFormat: 'pdf',
    };

    this.generatePdfLink = this.generatePdfLink.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDistanceChange = this.handleDistanceChange.bind(this);
    this.handleRadiiChange = this.handleRadiiChange.bind(this);
    this.handleFormatChange = this.handleFormatChange.bind(this);
    this.validateLink = this.validateLink.bind(this);
  }

  generatePdfLink() {
    if (!this.state.bufferRadii.length) {
      return '';
    }

    return generateReportLink({
      ...this.state,
      report: this.state.report.report,
      reportTitle: this.state.report.title,
      format: this.state.reportFormat,
    });
  }

  handleChange(event) {
    const report = this.reports.find(rep => rep.report === event.target.value);
    this.setState({ [event.target.name]: report });
  }

  handleDistanceChange(event) {
    const { name, value } = event.target;
    const bufferUnits = value === 'DriveTimeBufferBands' ? 'minutes' : 'miles';
    this.setState({
      bufferUnits,
      [name]: value,
    });
  }

  handleRadiiChange(index) {
    return event => {
      const radius = event.target.value;
      const updated = [...this.state.bufferRadii];
      updated[index] = radius;
      this.setState({ bufferRadii: updated });
    };
  }

  handleFormatChange(event) {
    this.setState({ reportFormat: event.target.value });
  }

  validateLink() {
    const radii = this.state.bufferRadii.filter(radius => radius);
    if (!radii.length) {
      return {
        pointerEvents: 'none',
        opacity: 0.2,
      };
    }
    return {};
  }

  render() {
    const { onModalClick, property } = this.props;
    const propertyName = property.name || '';

    return (
      <div className="modal-wrapper building-modal">
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <div className="modal-header">
            <h2 className="modal-title">ESRI Reports</h2>
            <a tabIndex="0" onClick={onModalClick}>
              <div className="modal-close">
                {svgInline(closeIcon)}
              </div>
            </a>
          </div>
        </ViewerPrimaryColorUserStyle>
        <div className="modal-body demographic-modal-form">
          <h2>{propertyName}</h2>

          <form>
            <div className="form-group">
              <label htmlFor="reportType">Report Type</label>
              <select
                className="form-control"
                name="report"
                id="report"
                value={this.state.report.report}
                onChange={this.handleChange}
              >
                {
                  this.reports.map(report => (
                    <option key={report.report} value={report.report}>{report.title}</option>
                  ))
                }
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="reportArea">Report Area</label>
              <select
                className="form-control"
                name="areaType"
                id="areaType"
                value={this.state.areaType}
                onChange={this.handleDistanceChange}
              >
                <option value="DriveTimeBufferBands">Drive Time</option>
                <option value="RingBuffer">Distance</option>
              </select>
            </div>
            {false &&
            <section className="form-group">
              <input
                type="radio"
                className="tab-toggle__tab"
                id="distance_minutes"
                name="bufferUnits"
                value="esriDriveTimeUnitsMinutes"
                onChange={this.handleChange}
              />
              <label htmlFor="distance_minutes">Minutes</label>
              <input
                type="radio"
                className="tab-toggle__tab"
                id="distance_miles"
                name="bufferUnits"
                value="esriMiles"
                onChange={this.handleChange}
              />
              <label htmlFor="distance_miles">Miles</label>
            </section>
            }
            <div className="form-inline">
              <div>
                <span><b>Radii in {this.state.bufferUnits}: </b></span>
                <div className="form-group radius-inputs">
                  <input type="text" value={this.state.bufferRadii[0]} onChange={this.handleRadiiChange(0)} />
                  <input type="text" value={this.state.bufferRadii[1]} onChange={this.handleRadiiChange(1)} />
                  <input type="text" value={this.state.bufferRadii[2]} onChange={this.handleRadiiChange(2)} />
                </div>
              </div>
              <span className="ml-30">Radii Values Adjustable</span>
            </div>
            <div className="form-group">
              <label htmlFor="reportFormat">Report Format</label>
              <div>
                <label>
                  <input
                    type="radio"
                    name="reportFormat"
                    value="pdf"
                    checked={this.state.reportFormat === 'pdf'}
                    onChange={this.handleFormatChange}
                  />
                  {' '}PDF
                </label>
                <label style={{ marginLeft: '15px' }}>
                  <input
                    type="radio"
                    name="reportFormat"
                    value="xlsx"
                    checked={this.state.reportFormat === 'xlsx'}
                    onChange={this.handleFormatChange}
                  />
                  {' '}Excel
                </label>
              </div>
            </div>
          </form>
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <a
              className="btn"
              style={this.validateLink()}
              target="_blank"
              rel="noopener noreferrer"
              href={this.generatePdfLink()}
              onClick={onModalClick}
            >
              Generate Report
            </a>
          </ViewerPrimaryColorUserStyle>
        </div>
      </div>
    );
  }
}

ReportsModalComponent.propTypes = {
  onModalClick: PropTypes.func,
  property: PropTypes.object,
};

export default withModal(ReportsModalComponent, 'report');



// WEBPACK FOOTER //
// ./src/components/ReportsModal/ReportsModal.js